export default __webpack_public_path__ + "static/media/development-2.c0692686.png";